import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {InputStatus} from '../models/input-status-type';
import {SecurePassword} from './model/secure-password';
import {SecurePasswordService} from './services/secure-password.service';
import {SessionStorageKeysEnum} from '../models/session-storage-keys-enum';
import '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import {BdbSessionStrgService} from '@npm-bbta/bbog-cm-auth-lib';
import HttpStatusCode from '../enums/http-status.enum';
import {NewServiceErrorEnum} from '../enums/new-service-error.enum';
import {Router} from '@angular/router';
import {AuthenticationErrors, SecurePasswordClientModel} from '../models/client.model';
import {ProcessAuthenticationService} from '../shared/process-authentication.service';
import {RedirectService} from '../shared/redirect.service';
import {ServiceErrorEnum} from '../enums/service-error.enum';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-bdb-secure-password',
    templateUrl: './bdb-secure-password.component.html',
    styleUrls: ['./bdb-secure-password.component.scss']
})
export class BdbSecurePasswordComponent implements OnInit {
    inputStatus: InputStatus = 'ENABLED';
    inputPassword: string;
    isButtonDisabled = true;

    private readonly wrongSecurePasswordMessage = `La clave ingresada no es correcta, verifica y vuelve a intentarlo.
                                           (${ServiceErrorEnum.CHECKPIN_WRONG_PASSWORD})`;

    private readonly toolTipSecurePasswordMessage = `Con La Clave segura puedes ingresar más fácil, rápido y
                                                     seguro a todos nuestros canales digitales, si aun no la
                                                     tienes descarga nuestra app del Banco de Bogotá, regístrate
                                                     y crea tu clave.`

    @ViewChild('toastError') bdbAtToast: ElementRef;
    @ViewChild('loader') loader: ElementRef;
    @ViewChild('input') input: ElementRef;

    constructor(private readonly bdbSessionStorageService: BdbSessionStrgService,
                private readonly processAuthenticationService: ProcessAuthenticationService,
                private readonly router: Router,
                private readonly redirectService: RedirectService,
                private readonly securePasswordService: SecurePasswordService) {
    }

    ngOnInit() {
    }

    inputChanged(event: any): void {
        this.inputPassword = event.detail.value;
        this.isButtonDisabled = this.inputPassword.length !== 4;
        if (this.inputPassword.length <= 3) {
            this.inputStatus = 'ENABLED';
        }
    }

    async buttonClick(): Promise<void> {
        await this.loader.nativeElement.openAlert();
        const securePasswordModel: SecurePassword = {
            documentType: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE),
            documentNumber: this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER),
            uuid: this.bdbSessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH),
            password: this.inputPassword
        };
        try {
            const isSandboxV3Active = environment.validateSecureKeyUseSandboxV3;
            let response;
            response = isSandboxV3Active ?
                await this.securePasswordService.universalKeyWithSandboxV3(securePasswordModel) :
                await this.securePasswordService.validateSecurePassword(securePasswordModel);
            const securePasswordClientModel: SecurePasswordClientModel = new SecurePasswordClientModel();
            let isSuccessAuthAttempt = false;
            let errorMessage = '';
            try {
                isSuccessAuthAttempt =
                    this.processAuthenticationService.getProcessAuthenticationSecureKey(response, securePasswordClientModel);
            } catch (error) {
                errorMessage = error.message;
            }
            await this.loader.nativeElement.handleCloseClick();
            console.log("miResponse",response)
            if (isSuccessAuthAttempt) {
                this.redirectService.redirectFromAuthentication();
            } else if (response.status === HttpStatusCode.UNAUTHORIZED
                || errorMessage === AuthenticationErrors.PASSWORD_IS_WRONG) {
                console.log(this.wrongSecurePasswordMessage);
                console.log(this.toolTipSecurePasswordMessage);
                this.inputStatus = 'ERROR';
                this.bdbAtToast.nativeElement.show();
            } else if (response.body.code === HttpStatusCode.UNAUTHORIZED
                || response.errorCode === AuthenticationErrors.PASSWORD_BLOCKED) {
                this.redirectToErrorScreen(NewServiceErrorEnum.BLOCKED_SECURE_KEY);
            } else if (response.body.code === HttpStatusCode.CONFLICT
                || response.errorCode === AuthenticationErrors.PASSWORD_WRONG) {
                console.log(this.wrongSecurePasswordMessage);
                console.log(this.toolTipSecurePasswordMessage);
                this.inputStatus = 'ERROR';
                this.bdbAtToast.nativeElement.show();
            }else if (response.status === HttpStatusCode.LOCKED
                || errorMessage === AuthenticationErrors.PASSWORD_IS_BLOCKED) {
                this.redirectToErrorScreen(NewServiceErrorEnum.BLOCKED_SEC_PASS);
            } else {
                this.redirectToErrorScreen(NewServiceErrorEnum.CHECKPIN_SERVICE_FAILURE);
            }
        } catch (e) {
            console.error(e);
            await this.loader.nativeElement.handleCloseClick();
            this.redirectToErrorScreen(NewServiceErrorEnum.CHECKPIN_SERVICE_FAILURE);
        }
    }

    private redirectToErrorScreen(errorCode: NewServiceErrorEnum): void {
        this.bdbSessionStorageService.save(SessionStorageKeysEnum.ERROR_CODE, errorCode);
        this.router.navigate(['error']);
    }

    backButtonClicked(event: any) {
        this.router.navigate(['second-factor-selector']);
    }

    closeButtonCLicked(event: any) {
        this.router.navigate(['identity-number']);
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-secure-password/bdb-secure-password.component.ts